import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const accessToken = authService.accessToken();
  const tenantUuid = authService.userConfig()?.company?.uuid || '';

  const isProtectedRoute = req.url.startsWith(environment.authUrl) || req.url.startsWith(environment.apiUrl);

  if (accessToken && isProtectedRoute) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'X-Tenant-Uuid': tenantUuid,
      },
    });
  }

  return next(req);
};
